import React from "react";
import styled from "styled-components";
import { useGames } from "../../../../contexts/GamesContext";
import useGameLogos from "../../../../customhooks/useGameLogos";
import defaultMlbLogo from "../../../assets/logo/mlb-major-league-baseball-logo.png";

const PreviewImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  min-width: 115px;
  height: 130px;
  background-color: #fff;
  padding: 4px 0;
  border: 1px solid #bccadc;
  border-radius: 4px;
`;

const MlbLogoImage = styled.img`
  max-width: 35px;
  max-height: 30px;
  object-fit: contain;
`;

const TeamLogosRow = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
  justify-content: center;
`;

const TeamLogoImage = styled.img`
  max-width: 42px;
  max-height: 42px;
  object-fit: contain;
`;

const PreviewImage = ({ refreshKey }) => {
  const {
    state: { selectedOrg, otherOrg, selectedGames },
  } = useGames();
  const selectedGame = selectedGames[0];

  const { topLogo, bottomLogo, teamLogo, otherOrgLogo, loading } = useGameLogos({
    clubId: selectedOrg?.value,
    gamePk: selectedGame?.gamePk,
    otherOrgId: otherOrg?.value,
    refreshKey,
  });

  return (
    <PreviewImageContainer>
      {loading ? (
        <div>Loading...</div>
      ) : (
        <>
          <MlbLogoImage src={topLogo || defaultMlbLogo} alt="MLB logo" />
          <TeamLogosRow>
            {teamLogo && <TeamLogoImage src={teamLogo} alt="Selected team logo" />}
            {otherOrgLogo && <TeamLogoImage src={otherOrgLogo} alt="Other team logo" />}
          </TeamLogosRow>
          <MlbLogoImage src={bottomLogo || defaultMlbLogo} alt="MLB logo" />
        </>
      )}
    </PreviewImageContainer>
  );
};

export default PreviewImage;
